import React, { createContext, useContext, useState, useCallback } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('app_language') || 'es';
  });

  const toggleLanguage = () => {
    setLanguage(prev => {
      const next = prev === 'en' ? 'es' : 'en';
      localStorage.setItem('app_language', next);
      return next;
    });
  };

  // Language is strictly role-based: trainer/admin → EN, client → ES.
  // No in-app manual toggle (kept simple per product decision).
  const setLanguageForRole = useCallback((role) => {
    const lang = (role === 'client') ? 'es' : 'en';
    localStorage.setItem('app_language', lang);
    setLanguage(lang);
  }, []);

  const manualToggleLanguage = () => {
    localStorage.setItem('app_language_manual', 'true');
    toggleLanguage();
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage: manualToggleLanguage, setLanguageForRole }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
